import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

export interface IBreadcrumb {
  url: string;
  label: string; // rendered label
  labelWithTemplateVars?: string; // stores un-processed label with dynamic {{variables}}
  params?: Params;
}

/** ? */
@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {
  public breadcrumb: BehaviorSubject<IBreadcrumb[]> = new BehaviorSubject([]);
  public breadcrumbLabels: BehaviorSubject<{ [key: string]: string }> = new BehaviorSubject<{
    [key: string]: string;
  }>({});

  public updateLabels(labels: { [key: string]: string }): void {
    this.breadcrumbLabels.next(labels);
  }

  public add(crumb: IBreadcrumb): void {
    this.breadcrumb.next(this.breadcrumb.getValue().concat([crumb]));
  }

  public reset(crumbs: IBreadcrumb[] = []): void {
    this.breadcrumb.next(crumbs);
  }

  public get(): IBreadcrumb[] {
    return this.breadcrumb.getValue();
  }
}
